module.exports = __webpack_public_path__ + "img/bvn-failed.df4ffcea.svg";